import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { map, sortBy } from "lodash";

import FontIcon from "react-md/lib/FontIcons";

import { setActiveHost, setActiveServer } from "../../actions/activeActions";
import {DebugElement} from "../../Atollon/debug";
import {array_utilities} from "../../Atollon/utilities/array_utilities";

const Table = ({ history, host, setActiveHost, setActiveServer }) => {
  return (
    <div className="table">
        <DebugElement text="src/components/host/Table.js"/>
      <div className="table-row header">
        <div className="table-col">Název</div>
        <div className="table-col">Vyhrazen</div>
        <div className="table-col">Počet organizací</div>
        <div className="table-col actions">Akce</div>
      </div>
      {map( array_utilities.array_of_structs_locale_sort_by_array_of_field_names( host.servers, ['name'] ), (item, i) => (
        <div
          className="table-row"
          key={i}
          onClick={() => history.push(`/hosts/${host.id}/${item.id}`)}
        >
          <div className="table-col">{item.name}</div>
          <div className="table-col">{item.dedicated ? "Ano" : "Ne"}</div>
          <div className="table-col">{item.organizations.length}</div>
          <div className="table-col actions">
            <FontIcon
              className="icon"
              onClick={e => {
                e.stopPropagation();
                setActiveHost(host);
                setActiveServer(item);
                history.push("/remove-server");
              }}
            >
              delete
            </FontIcon>
          </div>
        </div>
      ))}
    </div>
  );
};

export default compose(connect(null, { setActiveHost, setActiveServer }))(
  Table
);



// WEBPACK FOOTER //
// ./src/components/host/Table.js